var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-card-global-sales"},[_c('md-card-header',{staticClass:"md-card-header-icon",class:_vm.getClass(_vm.headerColor)},[_vm._t("header")],2),_vm._v(" "),_c('md-card-content',[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }